export const GET_PROMO_LINKEDIN = 'GET_PROMO_LINKEDIN';
export const SET_PROMO_LINKEDIN = 'SET_PROMO_LINKEDIN';
export const ERROR_PROMO_LINKEDIN = 'ERROR_PROMO_LINKEDIN';